<template>
	<section class="ux1-application">
		<SystemLayout />
		<NotificationsNode />
	</section>
</template>

<script>
	export default {
		name: 'App',
		inheritAttrs: false
	};
</script>

<script setup>
	import Vue from 'vue';

	import SystemLayout from '@/HostApp/ui/components/layout/SystemLayout.vue';
	import NotificationsNode from '@/HostApp/ui/system/NotificationsNode.vue';
	import NavBar from '@/HostApp/ui/components/Dojo2Vue/NavBar.vue';
	import SideBar from '@/HostApp/ui/components/Dojo2Vue/SideBar.vue';
	import Notifications from '@/HostApp/ui/components/Dojo2Vue/Notifications.vue';
	import Impersonated from '@/HostApp/ui/components/Dojo2Vue/Impersonated.vue';
	import NavBarAnonymous from '@/HostApp/ui/components/Dojo2Vue/NavBarAnonymous.vue';
	import TheBanner from '@/HostApp/ui/components/wraps/TheBanner.vue';
	import TheNavBar from '@/HostApp/ui/components/wraps/TheNavBar.vue';
	import TheSideBar from '@/HostApp/ui/components/wraps/TheSideBar.vue';
	import TheAlertNode from '@/HostApp/ui/system/AlertNode.vue';
	import TheNavPanel from '@/HostApp/ui/system/TheNavPanel.vue';
	import TheBreadcrumbs from '@/HostApp/ui/components/wraps/TheBreadcrumbs.vue';
	import TheContentTitle from '@/HostApp/ui/components/wraps/TheContentTitle.vue';
	import TheWizardSteps from '@/HostApp/ui/components/wraps/TheWizardSteps.vue';
	import HelpCenterNode from '@/HostApp/ui/system/HelpCenterNode.vue';
	import TheHelpCenterLink from '@/HostApp/ui/components/wraps/TheHelpCenterLink.vue';

	import AppView from '@/Framework/app/components/ApplicationView/AppView.vue';
	import ComputedLayout from '@/HostApp/ui/components/layout/ComputedLayout.vue';
	import Viewport from '@/HostApp/ui/system/Viewport.vue';
	import BacktopUIAddon from '@/HostApp/ui/components/wraps/BacktopUIAddon.vue';

	Vue.component('AppView', AppView);
	Vue.component('NavBar', NavBar);
	Vue.component('SideBar', SideBar);
	Vue.component('Notifications', Notifications);
	Vue.component('Impersonated', Impersonated);
	Vue.component('NavBarAnonymous', NavBarAnonymous);
	Vue.component('TheBanner', TheBanner);
	Vue.component('TheNavBar', TheNavBar);
	Vue.component('TheSideBar', TheSideBar);
	Vue.component('TheAlertNode', TheAlertNode);
	Vue.component('TheBreadcrumbs', TheBreadcrumbs);
	Vue.component('TheContentTitle', TheContentTitle);
	Vue.component('TheWizardSteps', TheWizardSteps);
	Vue.component('TheNavPanel', TheNavPanel);
	Vue.component('TheHelpCenterLink', TheHelpCenterLink);
	Vue.component('HelpCenterNode', HelpCenterNode);
	Vue.component('ComputedLayout', ComputedLayout);
	Vue.component('Viewport', Viewport);
	Vue.component('BacktopUIAddon', BacktopUIAddon);
</script>
